import { createParseAsEnumListFilter } from '@app/core/list-view/helpers/create-parse-as-enum-list-filter';
import { StationTypeFilterType } from '../components/options';

/**
 * nuqs parser for the status screen `type` query param.
 * Supports a comma-separated list (e.g. `radio,tv`) or a single value (e.g. `youtube`).
 * Null/absent means no station-type filter (show all types).
 */
export const parseAsStationTypeFilter = createParseAsEnumListFilter([
  StationTypeFilterType.RADIO,
  StationTypeFilterType.TV,
  StationTypeFilterType.YOUTUBE,
]);
